import { useState } from 'react'
import isEqual from 'lodash-es/isEqual'

function handleCreateDraftMarker({ editMode, position }) {
  return {
    draggable: editMode,
    name: 'editBuildingMarker',
    position,
  }
}

function getInitDraftBuildingMarker({ editMode, marker }) {
  return marker
    ? handleCreateDraftMarker({ editMode, position: marker?.position })
    : null
}

function getMarkerWithUpdatedPosition({ marker, nextPosition }) {
  return {
    ...marker,
    position: nextPosition,
  }
}

export function useManageBuildingMarker({ editMode, initialMarker }) {
  const [draftBuildingMarker, setDraftBuildingMarker] = useState(
    getInitDraftBuildingMarker({ editMode, marker: initialMarker })
  )

  // `prevMarker` starts as `undefined` so this runs on mount (like the
  // original `usePrevious`-based effect) and again whenever `initialMarker`
  // changes by value. `isEqual` guards against new-but-equal references.
  const [prevMarker, setPrevMarker] = useState(undefined)

  if (!isEqual(prevMarker, initialMarker)) {
    setPrevMarker(initialMarker)

    let nextDraftBuildingMarker = initialMarker

    // update draft marker position if initial marker was changed
    if (initialMarker && draftBuildingMarker) {
      nextDraftBuildingMarker = getMarkerWithUpdatedPosition({
        marker: draftBuildingMarker,
        nextPosition: initialMarker.position,
      })
    }

    // create draft marker position if initial marker was changed
    if (editMode && !draftBuildingMarker && initialMarker) {
      nextDraftBuildingMarker = handleCreateDraftMarker({
        editMode,
        position: initialMarker.position,
      })
    }

    setDraftBuildingMarker(nextDraftBuildingMarker)
  }

  function handleMapClick(position) {
    if (editMode) {
      let markerEdit = { ...draftBuildingMarker }

      if (draftBuildingMarker) {
        markerEdit = getMarkerWithUpdatedPosition({
          marker: markerEdit,
          nextPosition: position,
        })
      } else {
        markerEdit = handleCreateDraftMarker({ editMode, position })
      }

      setDraftBuildingMarker(markerEdit)
    }
  }

  const marker = editMode ? draftBuildingMarker : initialMarker

  return {
    buildingMarker: marker,
    handleMapClick,
  }
}
